module.exports = __webpack_public_path__ + "img/cockfight icon 5.f3b691a5.png";